const ReactTableCell = ({ cell, isCellExpanded, editing }: any) => {
  return (
    <td
      {...cell.getCellProps()}
      className={isCellExpanded ? "expanded__cell" : undefined}
    >
      <div style={{ minWidth: cell.column.minWidth }}>
        {editing ? (
          <input value={cell.value} />
        ) : (
          cell.render("Cell", { isCellExpanded: isCellExpanded })
        )}
      </div>
    </td>
  );
};

export default ReactTableCell;
